import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state.tsx";
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { InfoRounded } from '@mui/icons-material';
import { closeModal, toggleLoading } from '../../../state/ModalSlice/ModalSlice.ts';
import CloseIcon from "@mui/icons-material/Close";
import { useBackend } from '../../../hooks/backend/useBackend.ts';
import { SECRETS_ENV } from '../../../Config/firebase.ts';
import { toast } from 'react-toastify';
import { Timestamp } from 'firebase/firestore';
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';
export default function PauseErrorModal() {
    const Dispatch = useAppDispatch();
    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading)
    const open = useAppSelector((state: RootState) => state.ModalSlice.PauseErrorModalOpen)
    const ServiceProviderID: string = useAppSelector(selectEffectiveUID) 
    const { LiveSubscriptionId, subscriptionId, orderMonth } = useAppSelector((state: RootState) => state.ArbitrarySlice.ForPauseErrorModal)

    // Handle Change Functions
    function handleClose() {
        Dispatch(closeModal("PauseErrorModalOpen"))
    }


    // On Submit operation
    const { axiosPostRequest } = useBackend("")
    const { update,updateArrayField } = useBackend(`/ServiceProviders/${ServiceProviderID}/LiveSubscriptions`)
    async function onSubmitWithoutWriteOff(){
        
        Dispatch(toggleLoading(true))
        try {
            update(LiveSubscriptionId, { status: "Paused" })
            updateArrayField(LiveSubscriptionId, "pauseHistory", { pauseTS: Timestamp.now() })
            toast.success("Student Paused Successfully")
        } catch (error) {
            toast.error("Error Pausing Student")
        }
        Dispatch(toggleLoading(false))
        handleClose()
    }

    async function onSubmit() {
        Dispatch(toggleLoading(true))
        try {
            const reqBody = {
                orderMonth : orderMonth, 
                serviceProviderId: ServiceProviderID,
                livesubscriptionId: LiveSubscriptionId, 
                subscriptionId:subscriptionId,
                liveSubStatus : "Paused"
            }
            const response = await axiosPostRequest(`${SECRETS_ENV.API_END_POINT}/api/writeOffExistingOrder`, reqBody)
            if(response.message === "Request successful"){
                update(LiveSubscriptionId, { status: "Paused" })
                updateArrayField(LiveSubscriptionId, "pauseHistory", { pauseTS: Timestamp.now() })
                toast.success("Student paused successfully")
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error("Error pausing student")
        }
        Dispatch(toggleLoading(false))
        handleClose()
    }
    



return (
    <Dialog
        sx={{
            padding: 0,
            '& .MuiPaper-root': {
                borderRadius: '10px',
            },

        }}
        maxWidth="md"
        open={open}
        disableEscapeKeyDown
        PaperProps={{
            component: 'div',
        }}
    >
        <DialogContent sx={{ paddingX: "60px", paddingY: "40px" }} className={"bg-white"}>
            <div className={"header pb-[20px] min-w-[550px]"}>
                <p className={"text-cf_heading font-[600] "}>Pause Student</p>
            </div>

            <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                <CloseIcon />
            </IconButton></div>

            <div className={"pt-0"}>
                <p>There are uncollected orders for the student in {orderMonth}. Would you like the orders to be written off? <span ><Tooltip title="The order will be marked as 'paid' with a total price of zero, reflecting a write-off."
                    arrow>
                    <button className={""} onClick={(e) => e.preventDefault()}>
                        <InfoRounded fontSize='small' />
                    </button>

                </Tooltip></span></p>
            </div>

            <div className={"flex gap-2 pt-8"}>
                <button onClick={onSubmitWithoutWriteOff} disabled={isLoading}
                    className={`w-full bg-cc_brand text-white  border-gray-500 p-1.5 rounded-lg flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>{isLoading &&
                        <CircularProgress sx={{ color: "white" }} size={20} />}
                    <p className={"ml-2"}>{isLoading ? "Loading" : "Continue without Write off"}</p>
                </button>
                <button
                    onClick={onSubmit} disabled={isLoading}
                    className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}>{isLoading &&
                        <CircularProgress sx={{ color: "white" }} size={20} />}
                    <p className={"ml-2"}>{isLoading ? "Loading" : "Write Off"}</p>
                </button>

            </div>
        </DialogContent>
    </Dialog>
);
}